import {
    THEME_COLORS,
    FONT_FAMILY,
    FONT_SIZE,
    FONT_WEIGHT,
    LINE_HEIGHT,
    TYPOGRAPHY_STYLES,
    SPACING,
    PADDING,
    MARGIN,
    GAP,
    COMPONENT_SIZES,
    Z_INDEX,
    SHADOWS,
    BORDERS,
    BORDER_RADIUS,
    ELEVATION_STYLES,
    BUTTON_BORDER_STYLES,
    TRANSITION_TIMING,
    TRANSITION_EASING,
    TRANSITIONS,
    ANIMATION_TIMING,
    ANIMATIONS,
    BREAKPOINTS_VALUES,
    MEDIA_QUERIES,
    ICON_SIZES,
    ICON_STROKE_WIDTH,
} from "../definitions";

export const THEME_ITAPTEC = {
    name: "itaptec",
    label: "Itaptec",

    colors: THEME_COLORS,

    typography: {
        fontFamily: FONT_FAMILY,
        fontSize: FONT_SIZE,
        fontWeight: FONT_WEIGHT,
        lineHeight: LINE_HEIGHT,
        styles: TYPOGRAPHY_STYLES,
    },

    spacing: {
        values: SPACING,
        padding: PADDING,
        margin: MARGIN,
        gap: GAP,
    },

    components: {
        sizes: COMPONENT_SIZES,
        zIndex: Z_INDEX,
    },

    visual: {
        shadows: SHADOWS,
        borders: BORDERS,
        borderRadius: BORDER_RADIUS,
        elevation: ELEVATION_STYLES,
        buttonBorders: BUTTON_BORDER_STYLES,
    },

    animation: {
        timing: TRANSITION_TIMING,
        easing: TRANSITION_EASING,
        transitions: TRANSITIONS,
        animationTiming: ANIMATION_TIMING,
        animations: ANIMATIONS,
    },

    responsive: {
        breakpoints: BREAKPOINTS_VALUES,
        mediaQueries: MEDIA_QUERIES,
    },

    icons: {
        sizes: ICON_SIZES,
        strokeWidth: ICON_STROKE_WIDTH,
    },
} as const;

export type ThemeItaptec = typeof THEME_ITAPTEC;
